import { Spin } from "../../../../../../shared/frontend/ui";
import React from "react";
import { Navigate,useLocation } from "react-router-dom";
import type { AuthRole } from "../api/types";
import { useAuth } from "./useAuth";
import { ROUTE_ADMIN } from "../constants/appRoutes";
import { PLATFORM_ADMIN_ROLE } from "../constants/authRole";

export function RequireAuth(props: { children: React.ReactNode; role?: AuthRole }) {
  const auth = useAuth();
  const loc = useLocation();

  if (!auth.isReady) {
    return (
      <div style={{ height: "100%", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!auth.token) {
    // Slashes sind im Query-Teil erlaubt — unkodiert lassen, damit die URL lesbar bleibt.
    const next = encodeURIComponent(loc.pathname + loc.search).replace(/%2F/gi, "/");
    // Admin-Bereich ohne Session: direkt zum Admin-Login, nicht zum Portal-Login.
    const isAdminArea = loc.pathname === ROUTE_ADMIN || loc.pathname.startsWith("/admin/");
    return <Navigate to={`${isAdminArea ? "/admin/login" : "/login"}?next=${next}`} replace />;
  }

  if (props.role && (auth.info?.role || "") !== props.role) {
    // Special-case: PlatformAdmin pages should offer a clean "switch user" flow.
    // Instead of landing on /forbidden (which keeps the normal session), we redirect to /admin/login
    // where we log out and then show the login screen with the correct "next" target.
    if (props.role === PLATFORM_ADMIN_ROLE) {
      return <Navigate to={`/admin/login?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
    }
    return <Navigate to="/forbidden" replace />;
  }

  return <>{props.children}</>;
}









